import * as React from 'react';

function IconActionLogoutLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M9.13957 14.6379L12.1288 11.6486L10.7239 10.2436L5.33325 15.6343L10.7239 21.0249L12.1288 19.62L9.13957 16.6307H14.7096V14.6379H9.13957ZM14.7096 6.6665V14.6379H20.6881V16.6307H14.7096V24.602H26.6666V6.6665H14.7096Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconActionLogoutLarge;
